import { createWebHistory, createRouter } from 'vue-router';
import pathLoader from '../plugins/loader'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: pathLoader('home'),
  },
  { path: '/tickets', name: 'HomeTickets', component: pathLoader('home') },
  { path: '/partners', name: 'HomePartners', component: pathLoader('home') },
  { path: '/speaker', name: 'HomeSpeaker', component: pathLoader('home') },
  { path: '/feedback', name: 'HomeFeedback', component: pathLoader('home') },
  { path: '/faq', name: 'HomeFaq', component: pathLoader('home') },
  { path: '/contacts', name: 'HomeContacts', component: pathLoader('home') },
  
  {
    path: '/cart',
    name: 'Cart',
    component: pathLoader('cart'),
  },
  {
    path: '/success',
    name: 'Success',
    component: pathLoader('success'),
  },
  {
    path: '/verifier-ticket',
    name: 'Verification',
    component: pathLoader('verification'),
  },
  {
    path: '/speakers',
    name: 'Speakers',
    component: pathLoader('speakers'),
  },
  {
    path: '/become-speaker',
    name: 'BecomeSpeaker',
    component: pathLoader('become-speaker'),
  },
  {
    path: '/calendrier',
    name: 'Calendrier',
    component: pathLoader('calendrier'),
  },
  {
    path: '/submit-presentation',
    name: 'SubmitPresentation',
    component: pathLoader('submit-presentation'),
  },
  {
    path: '/partners-redirect',
    name: 'PartnerRedirect',
    component: pathLoader('partners'),
  },
  {
    path: '/partners/apply',
    name: 'PartnerApply',
    component: pathLoader('partner-apply'),
  },
  {
    path: '/hackathon',
    name: 'Hackathon',
    component: pathLoader('hackathon'),
  },
  {
    path: '/hackathon/apply',
    name: 'HackathonApply',
    component: pathLoader('hackathon-apply'),
  },
  {
    path: '/bitcoin-dev-day',
    name: 'BitcoinDevDay',
    component: pathLoader('bitcoin-dev-day'),
  },
  {
    path: '/bitcoin-dev-day/propose',
    name: 'DevDayPropose',
    component: pathLoader('devday-propose'),
  },
  {
    path: '/devday-register',
    name: 'DevDayRegister',
    component: pathLoader('devday-register'),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    
    const sectionMap = {
      '/tickets': '#tickets',
      '/partners': '#partners',
      '/speaker': '#speakers',
      '/feedback': '#feedback',
      '/faq': '#faq',
      '/contacts': '#contacts'
    };

    if (sectionMap[to.path]) {
      return { 
        el: sectionMap[to.path], 
        behavior: 'smooth',
        top: 80 // Offset for the fixed header
      };
    }
    
    return { top: 0 };
  },
});

export default router;
